import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import Zodiac from './types/zodiac';
import Chinese from './types/chinese';

class Component extends BaseComponent {
    render({ type, slant, path, hash, button_text}) {
        let ChooserType = null;
        if (type == 'zodiac') {
            ChooserType = Zodiac;
        } else if (type == 'chinese') {
            ChooserType = Chinese;
        }

        if (ChooserType) {
            return (
                <compatibility-chooser>
                    <ChooserType slant={slant} />
                    <div class='button-wrapper'>
                        <button
                          class={`button-warning${path && hash ? '' : ' disabled'}`}
                          onClick={this.getReport}
                        >
                            {button_text}
                        </button>
                    </div>
                </compatibility-chooser>
            );
        }

        return null;
    }

    getReport = () => {
        const signup_gateway = document.querySelector('input[name="signup_gateway"]');

        if (signup_gateway) {
            signup_gateway.value = `compat-tag-${this.props.slant}`;
        }

        if (this.props.path && this.props.hash) {
            this.props.report(this.state);
        }
    }
}

const mapStateToProps = (state) => ({
    path: state['compatibility-chooser'] && state['compatibility-chooser'].path,
    hash: state['compatibility-chooser'] && state['compatibility-chooser'].hash,
    button_text: state['compatibility-chooser'] && state['compatibility-chooser'].submitting
        ? 'submitting…'
        : 'GET YOUR REPORT',
});

const mapDispatchToProps = (dispatch) => ({
    report: (payload) => dispatch({ type: 'compatibility-chooser:report', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/compatibility/chooser.js